/* eslint-disable react/prop-types */
import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "App";
import { AuthProvider } from "layouts/authentication/auth/auth";
import { MaterialUIControllerProvider } from "context";
import axios from "axios";
import { HelmetProvider } from "react-helmet-async";

// Configure axios to send cookies with all requests
axios.defaults.withCredentials = true;

// Leaflet map styles
import "leaflet/dist/leaflet.css";
import "leaflet-draw/dist/leaflet.draw.css";

// Fix Leaflet default marker icons broken by webpack asset hashing
import L from "leaflet";
import markerIcon2x from "leaflet/dist/images/marker-icon-2x.png";
import markerIcon from "leaflet/dist/images/marker-icon.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
});

const container = document.getElementById("app");

// Always use createRoot (never hydrateRoot).
// Pre-rendered HTML from react-snap still serves its SEO purpose: search engine
// crawlers receive the static HTML directly. For real users, createRoot avoids
// all hydration mismatch crashes (#418, #423) that occurred because the
// server-rendered Landing Page HTML conflicted with the authenticated app state.
const root = createRoot(container);
root.render(
  <BrowserRouter>
    <MaterialUIControllerProvider>
      <AuthProvider>
        <HelmetProvider>
          <App />
        </HelmetProvider>
      </AuthProvider>
    </MaterialUIControllerProvider>
  </BrowserRouter>
);
